import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from './../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly baseUrl = environment.apiUrl;
  private readonly defaultHeaders = new HttpHeaders({ Accept: 'application/json' });

  constructor(private httpClient: HttpClient) {}

  private handleError(error: any): Observable<never> {
    return throwError(() => error);
  }

  private getJsonHeaders(): HttpHeaders {
    return this.defaultHeaders.set('Content-Type', 'application/json');
  }

  private createUrl(path: string): string {
    return `${this.baseUrl}${path}`;
  }

  get(path: string, params: HttpParams = new HttpParams(), retryCount = 0): Observable<any> {
    return this.httpClient
      .get(this.createUrl(path), { headers: this.getJsonHeaders(), params })
      .pipe(retry(retryCount), catchError(error => this.handleError(error)));
  }

  post(path: string, body: any = {}): Observable<any> {
    const headers = body instanceof FormData ? this.defaultHeaders : this.getJsonHeaders();
    return this.httpClient
      .post(this.createUrl(path), body, { headers })
      .pipe(catchError(error => this.handleError(error)));
  }

  put(path: string, body: any = {}): Observable<any> {
    return this.httpClient
      .put(this.createUrl(path), body, { headers: this.getJsonHeaders() })
      .pipe(catchError(error => this.handleError(error)));
  }

  patch(path: string, body: any = {}): Observable<any> {
    return this.httpClient
      .patch(this.createUrl(path), body, { headers: this.getJsonHeaders() })
      .pipe(catchError(error => this.handleError(error)));
  }

  delete(path: string, params: HttpParams = new HttpParams(), body?: any): Observable<any> {
    return this.httpClient
      .delete(this.createUrl(path), { headers: this.getJsonHeaders(), params, body })
      .pipe(catchError(error => this.handleError(error)));
  }

  upload(path: string, fileData: FormData): Observable<any> {
    return this.httpClient
      .post(this.createUrl(path), fileData, {
        headers: new HttpHeaders({ 'ngsw-bypass': '' }),
        reportProgress: true,
        observe: 'body',
      })
      .pipe(catchError(error => this.handleError(error)));
  }
}
